// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-product-tags',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './product-tags.component.html',
  styleUrl: './product-tags.component.scss',
})
export class ProductTagsComponent {
  // inputs
  tagsData = input.required<string[]>();
}
